import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'file',
    theme => `
		display: flex;
		align-items: center;
		position: relative;
		max-width: 200px;
		width: auto;
		height: 36px;
		font-size: 14px;
    background: ${theme.color.text.F};
		border: 1px solid ${theme.color.text.HB};
		border-radius: 3px;
		padding: 6px 8px;
    box-shadow: ${theme.color.text.B} 0 1px 3px;
		box-sizing: border-box;
	`
  ],
  [
    'fileName',
    `
		margin: 0 5px;
	`
  ],
  [
    'remove',
    theme => `
		color:	${theme.color.text.B2};
		cursor: pointer;

		&:hover {
			color: inherit;
		}
	`
  ]
]);
